export const ComparisonSection = () => {
  return (
    <section className="nd-section">
      <div className="fi" style={{ maxWidth: "660px" }}>
        <div className="ey">The HDG Difference</div>
        <h2 className="nd-h">
          Not a directory.
          <br />
          <em>Your competitive advantage.</em>
        </h2>
        <p className="nd-lead" style={{ marginBottom: 0 }}>
          65% of affluent homeowners delay hiring an interior designer because
          of confidence gaps — not budget. Home Design Guild is built to
          eliminate that gap entirely, replacing hours of searching with one
          confident, curated match.
        </p>
      </div>

      <div className="comp-box fi">
        <table className="comp">
          <thead>
            <tr>
              <th style={{ width: "28%" }}>What Matters</th>
              <th className="hc" style={{ width: "36%" }}>
                Home Design Guild
              </th>
              <th style={{ width: "36%" }}>Designer Directories</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Finding the right designer</td>
              <td className="hc">
                <span className="ck">✦</span>
                Smart-Guild Matching™ — personality, budget &amp; style
              </td>
              <td>
                <span className="cx">—</span>
                Search and guess from unverified listings
              </td>
            </tr>
            <tr>
              <td>Designer quality assurance</td>
              <td className="hc">
                <span className="ck">✦</span>
                HDG Authorized Seal on every designer
              </td>
              <td>
                <span className="cx">—</span>
                Quality and experience vary widely
              </td>
            </tr>
            <tr>
              <td>Time to match</td>
              <td className="hc">
                <span className="ck">✦</span>
                Curated matches delivered to you
              </td>
              <td>
                <span className="cx">—</span>
                Hours of browsing and outreach
              </td>
            </tr>
            <tr>
              <td>Hiring confidence</td>
              <td className="hc">
                <span className="ck">✦</span>
                Compatibility data + Designer Files
              </td>
              <td>
                <span className="cx">—</span>
                Reviews and assumptions only
              </td>
            </tr>
            <tr>
              <td>Overall experience</td>
              <td className="hc">
                <span className="ck">✦</span>
                Guided, structured, and enjoyable
              </td>
              <td>
                <span className="cx">—</span>
                Overwhelming and uncertain
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  );
};
